import React from 'react'
import { useTranslation } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { ImageSourceType } from '@makyoapp/makyo-common'
import { Image16, Youtube24 } from '@makyoapp/makyo-icon/icon'
import { SingleIconSelect } from '@makyoapp/makyo-ui'

import { useCreateColumnContext } from '@/context/CreateColumnContext'

import { ColumnDd } from './ColumnDd'
import { Fld, Lbl } from './shared'

interface ImageSourceOption {
  id: ImageSourceType
  icon: () => React.ReactNode
  title: string
}

interface DropdownProps {
  placeholder: string
  type: ColumnTypes
  valueKey: 'imgSourceGravatar' | 'imgSourceYoutube' | 'imgKeywords'
}

/**
 * handle select image source column depend on source type
 */
export function ImageColumnDropdown(props: DropdownProps) {
  const { id, value, setValue } = useCreateColumnContext()
  return (
    <ColumnDd
      types={[props.type]}
      id={`${id}-${props.valueKey.toLowerCase()}`}
      placeholder={props.placeholder}
      onChange={(opt) => {
        setValue({
          imageOptions: {
            ...value.imageOptions,
            [props.valueKey]: opt.id,
          },
        })
      }}
      selected={value.imageOptions[props.valueKey]}
    />
  )
}

/**
 * handle create column image options field
 */
export default function FieldImage() {
  const { t } = useTranslation()
  const { id, value, setValue } = useCreateColumnContext()
  let sourceLbl = t('URL Column')

  switch (value.imageOptions.imgSourceType) {
    case 'random':
      sourceLbl = t('Keywords')
      break
    case 'youtube':
      sourceLbl = t('Youtube URL')
      break
    case 'gravatar':
      sourceLbl = t('Email Address')
      break
    default:
      sourceLbl = t('URL Column')
      break
  }

  return (
    <>
      <Fld>
        <Lbl>{t('Image Source Type')}</Lbl>
        <SingleIconSelect
          id={`${id}-img-source-type`}
          onClick={(opt) => {
            setValue({
              imageOptions: {
                ...value.imageOptions,
                imgSourceType: opt.id as ImageSourceType,
              },
            })
          }}
          options={
            [
              {
                id: 'upload',
                icon: () => <Image16 width={24} height={24} />,
                title: t('File Upload'),
              },
              /*{
                id: 'gravatar',
                icon: () => <Gravatar16 width={24} height={24} />,
                title: t('Gravatar')
              },*/
              {
                id: 'youtube',
                icon: () => <Youtube24 />,
                title: t('Youtube Thumb'),
              },
              /*{
                id: 'random',
                icon: () => <Unsplash24 />,
                title: t('Random image from unsplash')
              }*/
            ] as ImageSourceOption[]
          }
          selected={value.imageOptions.imgSourceType}
        />
      </Fld>
      {value.imageOptions.imgSourceType !== 'upload' && (
        <Fld>
          <Lbl>{sourceLbl}</Lbl>
          {value.imageOptions.imgSourceType === 'gravatar' && (
            <ImageColumnDropdown
              type={ColumnTypes.Email}
              valueKey='imgSourceGravatar'
              placeholder={t('Select Email Column')}
            />
          )}
          {value.imageOptions.imgSourceType === 'youtube' && (
            <ImageColumnDropdown
              type={ColumnTypes.URL}
              valueKey={'imgSourceYoutube'}
              placeholder={t('Select URL Column')}
            />
          )}
          {value.imageOptions.imgSourceType === 'random' && (
            <ImageColumnDropdown placeholder={t('Select Text Column')} type={ColumnTypes.Text} valueKey='imgKeywords' />
          )}
        </Fld>
      )}
    </>
  )
}
